var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequeriments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5896 9.32447L27.0121 11.8491C28.8626 12.5718 28.8626 13.7666 27.0121 14.4893L20.5896 17.0139C19.8602 17.303 18.6628 17.303 17.9335 17.0139L11.511 14.4893C9.66041 13.7666 9.66041 12.5718 11.511 11.8491L17.9335 9.32447C18.6628 9.0354 19.8602 9.0354 20.5896 9.32447Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 17.2307C9.10791 18.029 9.81868 18.9507 10.6874 19.2738L18.3479 22.1437C18.9346 22.3623 19.6002 22.3623 20.1756 22.1437L27.8361 19.2738C28.7048 18.9507 29.4156 18.029 29.4156 17.2307",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 22.3076C9.10791 23.1914 9.72842 23.9896 10.6874 24.3507L18.3479 27.2206C18.9346 27.4392 19.6002 27.4392 20.1756 27.2206L27.8361 24.3507C28.7951 23.9896 29.4156 23.1914 29.4156 22.3076",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 35H23.45C31.7 35 35 31.7 35 23.45V13.55C35 5.3 31.7 2 23.45 2H13.55C5.3 2 2 5.3 2 13.55V23.45C2 31.7 5.3 35 13.55 35Z",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequeriments);
export default __webpack_public_path__ + "static/media/requeriments.830a3e8d1eb2498b3f27dbd4848d38af.svg";
export { ForwardRef as ReactComponent };